module.exports = __webpack_public_path__ + "img/img_nav_money_hover.0049ee2c.svg";